import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CustomerTaxProfileResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'customer': {
                    'code': 'C001',
                    'fantasy_name': 'Empresa Ejemplo',
                    'business_name': 'Empresa Ejemplo SA',
                    'taxpayer_identification_number': '20123456789'
                },
                'iva_situation_code': '1',
                'gross_tax_number': '20123456789',
                'sales_condition_code': 'A',
                'advance_payment_required': false
            },
            errors: []
        }
    }

    taxProfile() {
        const tax_profile = this.content();

        return {
            customer: {
                code: tax_profile.customer.code,
                fantasyName: tax_profile.customer.fantasy_name,
                businessName: tax_profile.customer.business_name,
                taxpayerIdentificationNumber: tax_profile.customer.taxpayer_identification_number
            },
            ivaSituationCode: tax_profile.iva_situation_code,
            grossTaxNumber: tax_profile.gross_tax_number,
            salesConditionCode: tax_profile.sales_condition_code,
            advancePaymentRequired: tax_profile.advance_payment_required
        }
    }
} 